import { Node, mergeAttributes } from "@tiptap/core"
import { ReactNodeViewRenderer, NodeViewWrapper } from "@tiptap/react"
import type { NodeViewProps } from "@tiptap/react"
import { useCrTemplateKeys } from "@/lib/queries"

function CrSlotComponent({ node }: NodeViewProps) {
  const templateKey = node.attrs.templateKey as string
  const { data: crTemplateKeys } = useCrTemplateKeys()

  const heading = (() => {
    const match = crTemplateKeys?.find((k) => k.template_key === templateKey)
    return match?.heading ?? templateKey
  })()

  return (
    <NodeViewWrapper as="span" className="inline">
      <span
        className="inline-flex items-center gap-1.5 bg-blue-50 border border-blue-200 text-blue-900 px-2.5 py-1 rounded-md text-sm align-middle"
        contentEditable={false}
      >
        <span className="bg-blue-600 text-white text-xs font-semibold px-1.5 py-0.5 rounded">
          CR
        </span>
        <span className="font-medium">{heading}</span>
      </span>
    </NodeViewWrapper>
  )
}

export const CrSlotExtension = Node.create({
  name: "crSlot",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      templateKey: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-cr-slot"),
        renderHTML: (attributes) => ({
          "data-cr-slot": attributes.templateKey,
        }),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: "span[data-cr-slot]",
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    const templateKey = HTMLAttributes["data-cr-slot"]
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-cr-slot": templateKey,
        contenteditable: "false",
        class: "cr-interpolated",
      }),
      `{${templateKey}}`,
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(CrSlotComponent)
  },
})
